<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-toolbox`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M33 6a2 2 0 012 2v4h9a2 2 0 012 2v26a2 2 0 01-2 2H4a2 2 0 01-2-2V14a2 2 0 012-2h9V8a2 2 0 012-2h18zM17 26H6v12h36V26H31a7 7 0 11-14 0zm7 3a3 3 0 01-3-3h6a3 3 0 01-3 3zm18-13H6v6h36v-6zm-25-6h14v2H17v-2z"/></svg>
</template>
<script>

export default {
  name: 'IconToolbox',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
